import {not, curry,  omit, mergeRight} from "ramda";
import validate from "validate.js";
import {isBlank, notBlank} from "./general";

export const firstError = curry(
  (errors, field) => (errors[field] ? errors[field][0] : ""),
);

export const hasError = curry(
    (errors, field) => not(isBlank(errors[field])),
);

export const validateField = curry((constraints, field, value, errors) => {
  const results = validate.single(value, constraints[field]);

  return results ? mergeRight(errors, { [field]: results }) : omit([field], errors);
});

export const validateObject = curry((constraints, obj) =>
  validate(obj, constraints) || {},
);

export const isRequired = (fieldOption, fieldOptions) => {
  return notBlank(fieldOptions[fieldOption]) && fieldOptions[fieldOption].required;
}